let randomValue; // 一些场景可能会用到灰度功能，取一个随机值作为参考值

try {
  const storeKey = '__dx_util_random__';
  const localRandomValue = localStorage.getItem(storeKey);

  if (localRandomValue) {
    randomValue = parseFloat(localRandomValue);
  } else {
    randomValue = Math.random();
    localStorage.setItem(storeKey, randomValue);
  }
} catch (e) {
  // 一些浏览器可能禁用了 localstorage 导致读写报错
  randomValue = Math.random();
}

export const _getImgRef = (el) => {
  if (window.__lazyload) {
    window.__lazyload.observeIntersection(el);
  }
};

const handleUrlSimplify = (url) => {
  const simplifyWhiteList = window.__simplify_white__ || [];
  const enableSimplify = simplifyWhiteList.some(({
    pattern,
    rate = 1,
  }) => {
    // 满足 url 正则匹配，且在灰度概率之内的，开启 simplify
    if (new RegExp(pattern).test(url) && randomValue < rate) {
      return true;
    } else {
      return undefined;
    }
  });

  if (enableSimplify) {
    // 对于开启 simplify 的 url ，在后面追加 simplify=1 的参数
    const paramsConnect = url.indexOf('?') > 0 ? '&' : '?';
    return `${url}${paramsConnect}simplify=1`;
  }

  return url;
};

export const handlerUrlFormat = (url) => {
  // if (!window.PAGE_DATA.modules.banner || !window.PAGE_DATA.modules.banner.useMsiteDomain) return url;
  let _url = url;
  if (/.*\/\/air.alibaba.com\/(.*)/.test(url)) {
    _url = `https://m.alibaba.com/air/${RegExp.$1}`;
  }
  if (/.*\/\/m-sale.alibaba.com\/(.*)/.test(url)) {
    _url = `https://m.alibaba.com/marketing/${RegExp.$1}`;
  }
  _url = handleUrlSimplify(_url);

  return _url;
};

export const handlerProductUrl = (p) => {
  const keyName = '__detailProductImg';
  const {
    p4p,
    productDetailUrl,
  } = p;
  let {

    productImg_resize,
  } = p;
  productImg_resize += '_q50.jpg';
  if (!p4p) {
    const encodedImageUrl = encodeURIComponent(productImg_resize);
    if (productDetailUrl.indexOf(keyName) !== -1) return productDetailUrl;

    if (productDetailUrl.indexOf('?') !== -1) {
      // 已经含有queryString
      return `${productDetailUrl}&${keyName}=${encodedImageUrl}`;
    } else {
      return `${productDetailUrl}?${keyName}=${encodedImageUrl}`;
    }
  } else {
    if (productDetailUrl.indexOf('toUrl') === -1) return productDetailUrl;

    const qmIndex = productDetailUrl.indexOf('?');
    const queryParams = parseQueryString(productDetailUrl.slice(qmIndex + 1));

    const decodedToUrl = decodeURIComponent(queryParams.toUrl);
    const toUrlHasQm = decodedToUrl.indexOf('?') > -1;
    queryParams.toUrl = encodeURIComponent(
      `${decodedToUrl + (toUrlHasQm ? '&' : '?')}${keyName}=${productImg_resize}`,
    );

    const queryString = stringify(queryParams);

    return `${productDetailUrl.slice(0, qmIndex)}?${queryString}`;
  }
};
export function parseQueryString(str = (window.location.search || '').slice(1)) {
  // eslint-disable-next-line no-return-assign
  return str.split('&').reduce((prev, kv) => (kv ? (prev[kv.split('=')[0]] = kv.split('=').slice(1).join(''), prev) : prev), {});
}


export function stringify(obj) {
  return Object.keys(obj || {}).map((k) => `${k}=${obj[k]}`).join('&');
}

export function getCategoryIDFromCurrentURL() {
  const url = new URL(location.href);
  const freepageArgsPage = url.searchParams.get('page');

  if (freepageArgsPage) {
    if (freepageArgsPage.startsWith('category_')) {
      const pageNamesSplit = freepageArgsPage.split('_');
      if (pageNamesSplit.length === 2) {
        return pageNamesSplit[1];
      }
    }
  } else if (url.pathname) {
    // seoUrl 从url取类目id
    const reg = /_p(\d+)$/;
    const execValues = reg.exec(url.pathname);
    if (execValues && execValues[1]) {
      return execValues[1];
    }
  }

  return null;
}

// 根据当前语种判断是否为 RTL 语种
export function isRTL() {
  const {
    lang,
  } = window.PAGE_DATA.common;
  return lang == 'ar_SA' || lang == 'iw_IL';
}

// 判断当前是否是 M 站首页
export function isMSiteHome() {
  const spmB = window.PAGE_DATA &&
    window.PAGE_DATA.pageInfo &&
    window.PAGE_DATA.pageInfo.traceInfo &&
    window.PAGE_DATA.pageInfo.traceInfo.spmB;
  if (spmB === '8172434') {
    return true;
  }
  return false;
}

// 判断当前是否为PWA/TWA应用
export function identifyTWA() {
  if (!isMSiteHome()) {
    return;
  }

  const PWA_FLAG = ['tracelog=51606102_9527_7259_7770&from=desktop', 'from=desktop_twa'];
  for (let i = 0, len = PWA_FLAG.length; i < len; i++) {
    if (window.location.search.indexOf(PWA_FLAG[i]) >= 0) {
      if (window.sessionStorage) {
        window.sessionStorage.setItem('PWA_MODLE_VISITOR', true);
      }
    }
  }
}


export const isAlibabaAppUrl = function (url) {
  let reAlibabaUrl = /^https?:\/\/([^\:\/]+\.)?(alibaba|aliexpress)\.com(\:\d+)?\//i;
  let reStyleUrl = /^https?:\/\/(style|img)\.(alibaba|aliexpress)\.com(\:\d+)?\//i;
  return (reAlibabaUrl.test(url) || (/^(\w+):\/\//i.test(url) === false && reAlibabaUrl.test(location.href))) && reStyleUrl.test(url) === false;
};

export const mixCsrfToken = function (url) {
  let cookie = document.cookie;
  let match = cookie && cookie.match(/(?:^|;)\s*xman_us_t\s*=\s*([^;]+)/);
  if (match) {
    match = match[1].match(/(?:^|&|")\s*ctoken\s*=\s*([^&]+)/);
  }
  let csrf_token = window['_intl_csrf_token_'] || (match && match[1]);

  if (csrf_token &&
    isAlibabaAppUrl(url) &&
    /(\?|&)ctoken=/.test(url) === false) {
    url += (/\?/.test(url) ? '&' : '?') + 'ctoken=' + csrf_token;
  }

  return url;
};

export const addParamForUrl = function (url, params) {
  const str = Object.keys(params).map(k => k + '=' + params[k]).join('&');
  url += url.indexOf('?') > -1 ? '&' : '?';
  return url += str;
};


export const getOffsetTop = (ele) => {
  let top = 0;
  const getTop = function  (el) {
    if (el) {
      top = top + el.offsetTop;
      if (el.offsetParent) {
        getTop(this,el.offsetParent);
      }
    }
    
  }
  getTop(ele);

  return top;
}